export default __webpack_public_path__ + "static/media/gabi.9afb543e.jpg";